import 'bootstrap/dist/css/bootstrap.min.css';
import { NavLink } from 'react-router-dom';

const links = [
    { to: '/home', label: 'Home' },
    { to: '/education', label: 'Education' },
    { to: '/career', label: 'Career' },
    { to: '/fsisel', label: 'FSISEL' },
    { to: '/personalprojects', label: 'Projects' },
    { to: '/contacts', label: 'Contacts' },
];

function Navbarm() {
    return (
        <nav className="navbar navbar-expand-lg site-nav">
            <div className="container">
                <NavLink className="navbar-brand" to="/home">Goncalo Ferraz</NavLink>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                        {links.map((link) => (
                            <li className="nav-item" key={link.to}>
                                <NavLink
                                    className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
                                    to={link.to}
                                >
                                    {link.label}
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </nav>
    );
}

export default Navbarm;
